import classNames from "classnames";
import { observer } from "mobx-react";
import styles from "./styles/CalendarBlock.module.scss";
import Calendar from "../../../utilities/CleverCalendar/CleverCalendar";
import { deleteContentItem } from "../Terrace";
import { useMountedEffect } from "../../../../hooks/useMountedEffect";
import { useStores } from "../../../../stores/useStores";
import { useGetEvents } from "../../../schoolfeed/hooks/useGetEvents";
import { IReactiveEventContentItem } from "../../../schoolfeed/SchoolFeedContentItem";

const calendarContainerClassName = classNames({
  [styles.calendarContainer]: true,
});

const CalendarBlock = observer((props: any) => {
  const { modalStore } = useStores();

  const { events, mutate, isLoading, setCurrentRange } = useGetEvents(
    "eventsTerrace",
    {
      organization_id: props.blockObj.organization_id,
      organization_pk: props.blockObj.organization_id,
    },
  );

  useMountedEffect(() => {
    // update when new events are added
    mutate();
  }, [props.blockObj.content_items.length]);

  const handleDelete = async (contentItem: any) => {
    await deleteContentItem(contentItem);
    modalStore.clearAllModals();
    mutate();
  };

  return (
    <div className={calendarContainerClassName}>
      <Calendar
        events={(events || []) as unknown as IReactiveEventContentItem[]}
        loading={isLoading}
        onRangeChange={setCurrentRange}
        aboveTheFold={props.aboveTheFold}
        expandedView={false}
        handleDeleteEvent={handleDelete}
      />
    </div>
  );
});

export default CalendarBlock;
